module.exports = __webpack_public_path__ + "img/img_size3_hc.491d1496.png";